import React from 'react';
import { CheckupRequestInfo } from '@companion-professional/dctypes';
import { Heading, Text } from '@companion-professional/components';

import BasePage from '../../base/BasePage';

interface StdSurveyPageProps {
  checkupRequest: CheckupRequestInfo;
  page: number;
}

// TODO: This is a skeleton template for the survey page.
// Will be implemented later with actual survey functionality.
// Expected to include:
// - Survey questions rendering
// - Form validation
// - Data submission
export const StdSurveyPage = ({ checkupRequest , page}: StdSurveyPageProps) => {
  const pageKind = 'std_survey';
  
  return (
    <BasePage
      pageKind={pageKind}
      page={page}
      checkupRequest={checkupRequest}
      renderChild={() => (
        <div className="flex w-full flex-1 flex-col justify-center items-center p-4">
          <div className="text-center space-y-4">
            <Heading level="page">Survey</Heading>
            <Text tone="muted">Survey functionality will be implemented here.</Text>
            <Text as="div" size="sm" tone="muted">
              Checkup ID: {checkupRequest.id}
            </Text>
          </div>
        </div>
      )}
    />
  )
};
